export default __webpack_public_path__ + "static/media/red_2.690dc1d0.png";